export default __webpack_public_path__ + "static/media/themebel_small.118894a0.svg";